<template>
  <div class="referral center-just">
    <div class="column">
      <!-- <el-image
        :src="$domain + 'static/noten/website/home/index1_title5_img.png'"
        style="width: 854px;height: 82px;align-self: center;cursor: pointer;"
      ></el-image> -->

      <div>
        <div class="center-just box-title" style="caret-color: transparent;">
          你将收获到：2大思维模式+2大核心能力
        </div>
      </div>

      <div class="between" style="margin-top: 50px;">
        <div class="center-just">
          <el-image
            :src="$domain + 'static/noten/website/home/index1_box5_img1.png'"
            style="cursor: pointer;margin-top: 28px;"
          ></el-image>
        </div>

        <el-image
          :src="$domain + 'static/noten/website/home/index1_box5_img2.png'"
          style="cursor: pointer;height: 520px;"
        ></el-image>
      </div>

      <div class="between">
        <el-image
          :src="$domain + 'static/noten/website/home/index1_box5_img4.png'"
          style="cursor: pointer;height: 520px;"
        ></el-image>
        <div class="center-just">
          <el-image
            :src="$domain + 'static/noten/website/home/index1_box5_img3.png'"
            style="cursor: pointer;margin-top: 28px;"
          ></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isHovering: false
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.hover-scale {
  transform: scale(1.05);
  transition: transform 0.3s ease-in-out;
}

.referral {
  height: 1306px;
  background-color: #fafbff;
}

.box-title {
  height: 46px;
  font-size: 46px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #1a1a1a;
}

.title-info {
  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  margin-top: 33px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/programming/box/box5.vue